import { useState } from 'react';
import styles from './ChallengeSubmissionForm.module.css';

export default function ChallengeSubmissionForm({ challenge, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    portfolio: '',
    submissionMethod: 'github',
    submissionLink: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(challenge.id, formData);
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        
        <h3 className={styles.modalTitle}>Submit Challenge #{challenge.id}</h3>
        <h4 className={styles.challengeTitle}>{challenge.title}</h4>
        
        <form onSubmit={handleSubmit} className={styles.submissionForm}>
          <div className={styles.formGroup}>
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          
          <div className={styles.formGroup}>
            <label htmlFor="portfolio">Portfolio/Website (optional)</label>
            <input
              type="url"
              id="portfolio"
              name="portfolio"
              value={formData.portfolio}
              onChange={handleInputChange}
              placeholder="https://"
            />
          </div>
          
          <div className={styles.formGroup}>
            <label>Submission Method</label>
            <div className={styles.radioGroup}>
              <label>
                <input
                  type="radio"
                  name="submissionMethod"
                  value="github"
                  checked={formData.submissionMethod === 'github'}
                  onChange={handleInputChange}
                />
                GitHub
              </label>
              <label>
                <input
                  type="radio"
                  name="submissionMethod"
                  value="figma"
                  checked={formData.submissionMethod === 'figma'}
                  onChange={handleInputChange}
                />
                Figma
              </label>
              <label>
                <input
                  type="radio"
                  name="submissionMethod"
                  value="loom"
                  checked={formData.submissionMethod === 'loom'}
                  onChange={handleInputChange}
                />
                Loom
              </label>
            </div>
          </div>
          
          <div className={styles.formGroup}>
            <label htmlFor="submissionLink">Submission Link</label>
            <input
              type="url"
              id="submissionLink"
              name="submissionLink"
              value={formData.submissionLink}
              onChange={handleInputChange}
              required
              placeholder="https://"
            />
          </div>
          
          <div className={styles.formGroup}>
            <label htmlFor="message">Additional Notes (optional)</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              rows="4"
              placeholder="Any additional information about your submission..."
            />
          </div>
          
          <div className={styles.buttonGroup}>
            <button type="button" className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles.submitButton}>
              Submit Challenge
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}